// extracted by mini-css-extract-plugin
module.exports = {"lightEmpty":"LrvEmpty_lightEmpty__1qdMC","darkEmpty":"LrvEmpty_darkEmpty__PQEhD"};